// // src/components/common/ConfirmDeleteDialog.jsx
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Typography,
//   CircularProgress,
// } from "@mui/material";

// export default function ConfirmDeleteDialog({
//   open,
//   title = "Delete agent",
//   description = "Are you sure you want to delete this agent? This action cannot be undone.",
//   confirmLabel = "Delete",
//   cancelLabel = "Cancel",
//   loading = false,
//   onCancel,
//   onConfirm,
// }) {
//   return (
//     <Dialog
//       open={open}
//       onClose={loading ? undefined : onCancel}
//       fullWidth
//       maxWidth="xs"
//     >
//       <DialogTitle>{title}</DialogTitle>
//       <DialogContent>
//         <Typography variant="body2" sx={{ mt: 1 }}>
//           {description}
//         </Typography>
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onCancel} disabled={loading}>
//           {cancelLabel}
//         </Button>
//         <Button
//           onClick={onConfirm}
//           variant="contained"
//           color="error"
//           disabled={loading}
//           startIcon={loading ? <CircularProgress size={16} /> : null}
//         >
//           {confirmLabel}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }

// src/components/agents/ConversationsDialog.jsx
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Chip,
  Box,
} from "@mui/material";
import { useEffect, useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  query,
  orderBy,
  limit,
  onSnapshot,
} from "firebase/firestore";

export default function ConversationsDialog({ open, onClose, agent }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!open || !agent?.id) return;

    // 🔍 vérif chemin Firestore côté client
    console.log(
      "[ConversationsDialog] path => messages / agent_" +
        agent.id +
        " / conversations"
    );

    const ref = collection(
      db,
      "messages",
      `agent_${agent.id}`,
      "conversations"
    );
    const q = query(ref, orderBy("updatedAt", "desc"), limit(100));
    const unsub = onSnapshot(
      q,
      (snap) => {
        const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        console.log("[ConversationsDialog] count:", rows.length);
        setItems(rows);
      },
      (err) => {
        console.error("[ConversationsDialog] onSnapshot error:", err);
      }
    );
    return () => unsub();
  }, [open, agent?.id]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Conversations — {agent?.name}</DialogTitle>
      <DialogContent dividers>
        <List>
          {items.map((c) => {
            const ts = c.updatedAt?.seconds
              ? new Date(c.updatedAt.seconds * 1000).toLocaleString()
              : "";
            const site = c.userHints?.site || c.userHints?.source || "unknown";
            return (
              <ListItem
                key={c.id}
                sx={{ borderBottom: "1px solid", borderColor: "divider" }}
              >
                <ListItemText
                  primary={
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <strong>{c.id}</strong>
                      {c.botActive === false && (
                        <Chip size="small" label="bot disabled" />
                      )}
                    </Box>
                  }
                  secondary={
                    <>
                      <span>Updated: {ts}</span>
                      {" • "}
                      <span>Interactions: {c.interactions ?? 0}</span>
                      {" • "}
                      <span>
                        Source: <strong>{site}</strong>
                      </span>
                    </>
                  }
                />
              </ListItem>
            );
          })}
          {items.length === 0 && (
            <Box sx={{ p: 2, textAlign: "center", color: "text.secondary" }}>
              Aucune conversation trouvée pour cet agent.
            </Box>
          )}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fermer</Button>
      </DialogActions>
    </Dialog>
  );
}
